import React from 'react';
import uniqueId from 'lodash/uniqueId';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const DisplayInfo = ({ info, onEdit, className, buttonLabel }) => {
  const { t } = useTranslation();
  const noneDataArr = ['Current job responsibilities', 'Prior experience with standardized testing'];
  const emptyDataMessage = label => (noneDataArr.indexOf(label) === -1 ? t('common.labels.notSpecified') : t('common.labels.none'));

  return (
    <div className={className}>
      {info.map(element =>
        (
          <p key={uniqueId(element.data)}>
            <span className="text-strong">{element.label}: </span>
            <span>
              {element.data ? element.data : emptyDataMessage(element.label)}
            </span>
          </p>
        ))
      }
      <button className="btn btn-small btn-outline m-0" onClick={onEdit}>{t(buttonLabel)}</button>
    </div>
  );
};

DisplayInfo.propTypes = {
  info: PropTypes.arrayOf(PropTypes.object).isRequired,
  onEdit: PropTypes.func.isRequired,
  className: PropTypes.string,
};

DisplayInfo.defaultProps = {
  className: '',
};

export default DisplayInfo;
